import { useEffect } from "react";

import { usePageTitle } from "@/atoms/page-title-atom";
import { useUser } from "@components/user-context";
import ProductAnalyticsPage from "@features/product-analytics";
import { ProductAnalyticsProvider } from "@features/product-analytics/context";
import { prettyLogEvent } from "@internal/analytics";
import { Pages } from "@north-beam/nb-client-side/constants";

export const ProductAnalytics = () => {
  const [, setPageTitle] = usePageTitle();

  const { user } = useUser();

  useEffect(() => {
    setPageTitle("Product Analytics");
  }, [setPageTitle]);

  useEffect(() => {
    prettyLogEvent.visited({
      page: Pages.PRODUCT_ANALYTICS,
      user,
    });
  }, [user]);

  return (
    <ProductAnalyticsProvider>
      <ProductAnalyticsPage />
    </ProductAnalyticsProvider>
  );
};
